/**
 * Preparatory Entry (Retired)
 * ---------------------------------------------------------------
 * The legacy Preparatory Entry UI has been retired. The canonical
 * production-entry screen for Warping / Covering / Spandex Warping /
 * Weaving / Finishing is `Department Production Entry`.
 *
 * This stub replaces the live posting surface at `/preparatory-entry`
 * so that any stale bookmark, dashboard shortcut, or breadcrumb lands
 * on an informational notice with a one-click redirect — never on a
 * live posting form. Direct navigation cannot create production
 * entries, post consumption, or mutate CWO status.
 *
 * The original component file `PreparatoryEntry.jsx` is retained on
 * disk but is no longer imported anywhere (verified via grep). It may
 * be hard-deleted in a future cleanup once RBAC + tests confirm no
 * dependency.
 */
import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";

export default function PreparatoryEntryRetired() {
  return (
    <div className="space-y-6" data-testid="preparatory-retired">
      <PageHeader
        overline="Production & Planning · Preparatory Entry"
        title="Preparatory Entry has been retired"
        subtitle="Use Department Production Entry for Warping, Covering, Spandex Warping, Weaving, and Finishing production posting."
      />
      <div className="tactical-card p-6 space-y-3">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Where to go</div>
        <div className="text-zinc-300 text-sm">
          The canonical entry surface is <span className="font-mono text-white">Department Production Entry</span>.
          It supports every preparatory stage with process-specific mode badges
          (<span className="text-cyan-300 font-mono">1:1 RM Conversion</span>,
          <span className="text-pink-300 font-mono ml-1">L2 BOM Auto Consumption</span>,
          <span className="text-amber-300 font-mono ml-1">1:1 SFC Conversion</span>).
        </div>
        <div className="pt-2">
          <Link to="/production/department-entry" data-testid="preparatory-retired-redirect"
            className="inline-flex items-center h-9 px-4 rounded-sm border border-[var(--accent)] bg-[var(--accent)] text-white text-xs font-mono uppercase tracking-widest hover:opacity-90">
            Open Department Production Entry
          </Link>
        </div>
      </div>
    </div>
  );
}
